(() => {
  const pageParam = 'jozee_page';
  const customFilterPrefix = 'jozee_';

  const getPageFromUrl = () => {
    const url = new URL(window.location.href);
    const page = parseInt(url.searchParams.get(pageParam) || url.searchParams.get('page') || '1', 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  };

  const pageUrl = (page) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set(pageParam, String(page));
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const hasCustomCollectionFilters = () => {
    const url = new URL(window.location.href);
    return Array.from(url.searchParams.keys()).some((key) => key.startsWith(customFilterPrefix));
  };

  const paginationItem = (page, currentPage) => {
    if (page === currentPage) {
      return `
        <li>
          <a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="Page ${page}">
            ${page}
          </a>
        </li>
      `;
    }

    return `
      <li>
        <a href="${pageUrl(page)}" class="pagination__item link" aria-label="Page ${page}" data-jozee-page-link="${page}">
          ${page}
        </a>
      </li>
    `;
  };

  const paginationEllipsis = () => '<li><span class="pagination__item">...</span></li>';

  const pagesToRender = (currentPage, totalPages) => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);

    const pages = [1];
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) pages.push('ellipsis-start');
    for (let page = start; page <= end; page += 1) pages.push(page);
    if (end < totalPages - 1) pages.push('ellipsis-end');
    pages.push(totalPages);

    return pages;
  };

  const renderControls = (controls, currentPage, totalPages) => {
    if (!controls || totalPages <= 1) {
      if (controls) controls.hidden = true;
      return;
    }

    const parts = pagesToRender(currentPage, totalPages)
      .map((page) => (typeof page === 'number' ? paginationItem(page, currentPage) : paginationEllipsis()))
      .join('');

    const previous = currentPage > 1
      ? `<li><a href="${pageUrl(currentPage - 1)}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Previous page" data-jozee-page-link="${currentPage - 1}">‹</a></li>`
      : '';
    const next = currentPage < totalPages
      ? `<li><a href="${pageUrl(currentPage + 1)}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Next page" data-jozee-page-link="${currentPage + 1}">›</a></li>`
      : '';

    controls.innerHTML = `<ul class="pagination__list list-unstyled" role="list">${previous}${parts}${next}</ul>`;
    controls.hidden = false;
  };

  const applyPagination = (grid) => {
    if (!grid || grid.dataset.jozeePaginationReady === 'true') return;

    const allItems = Array.from(grid.querySelectorAll('[data-jozee-product-card]'));
    const items = allItems.filter((item) => item.dataset.jozeeFilterHidden !== 'true');
    if (!allItems.length) return;

    const pageSize = parseInt(grid.dataset.jozeePageSize || '16', 10);
    if (!Number.isFinite(pageSize) || pageSize < 1) return;

    const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
    const currentPage = Math.min(getPageFromUrl(), totalPages);
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    const collection = grid.closest('.collection');
    const controls = collection?.querySelector('[data-jozee-client-pagination-controls]');
    const serverPagination = collection?.querySelector('[data-jozee-server-pagination]');
    const hasServerPages = parseInt(grid.dataset.jozeeServerPages || '1', 10) > 1;
    const hasLoadedCollectionProducts = grid.dataset.jozeeCollectionProductsLoaded === 'true'
      || grid.dataset.jozeeAllProductsLoaded === 'true';

    if (hasServerPages && !hasCustomCollectionFilters() && !hasLoadedCollectionProducts) {
      allItems.forEach((item, index) => {
        item.hidden = false;
        item.style.setProperty('--animation-order', String(index + 1));
      });
      if (controls) controls.hidden = true;
      if (serverPagination) serverPagination.hidden = false;
      grid.dataset.jozeePaginationReady = 'true';
      return;
    }

    if (serverPagination) serverPagination.hidden = true;

    allItems.forEach((item) => {
      item.hidden = true;
    });

    items.forEach((item, index) => {
      item.hidden = index < start || index >= end;
      item.style.setProperty('--animation-order', String((index - start) + 1));
    });

    renderControls(controls, currentPage, totalPages);
    grid.dataset.jozeePaginationReady = 'true';
  };

  const initCollectionPagination = () => {
    document.querySelectorAll('[data-jozee-client-pagination="true"]').forEach((grid) => {
      delete grid.dataset.jozeePaginationReady;
      applyPagination(grid);
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-jozee-page-link]');
    if (!link) return;

    event.preventDefault();
    window.history.pushState({}, '', link.href);
    initCollectionPagination();
    document.getElementById('ProductGridContainer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  window.addEventListener('popstate', initCollectionPagination);
  document.addEventListener('jozee:filters-updated', initCollectionPagination);
  document.addEventListener('DOMContentLoaded', initCollectionPagination);

  const observer = new MutationObserver((mutations) => {
    const productGridChanged = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return node.matches?.('[data-jozee-client-pagination="true"]')
          || node.querySelector?.('[data-jozee-client-pagination="true"]');
      }),
    );

    if (productGridChanged) initCollectionPagination();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const parameterPrefix = 'jozee_';
  const groups = ['category', 'craft', 'destination', 'brand'];

  const collectionHandle = () => {
    const container = document.querySelector('.facets-container[data-collection-handle]');
    return container?.dataset.collectionHandle || window.location.pathname.split('/').filter(Boolean).pop() || '';
  };

  const usesInPageCollectionFilters = () => Boolean(document.querySelector('[data-jozee-client-pagination="true"]'));

  const unique = (values) => Array.from(new Set(values.filter(Boolean)));

  const filterInputs = () => Array.from(document.querySelectorAll('[data-jozee-filter-input]'));

  const productCountElements = () => Array.from(document.querySelectorAll('#ProductCount, #ProductCountDesktop'));

  const mobileProductCountElements = () => Array.from(document.querySelectorAll('.mobile-facets__count'));

  const hasExplicitJozeeSelections = () => {
    const url = new URL(window.location.href);
    return groups.some((group) => url.searchParams.has(`${parameterPrefix}${group}`));
  };

  const selectedFilterInputs = () => filterInputs().filter((input) => input.checked);

  const navigateToCollection = (input) => {
    if (usesInPageCollectionFilters()) return false;
    if (!input.checked || !input.dataset.jozeeCollectionUrl) return false;

    const target = new URL(input.dataset.jozeeCollectionUrl, window.location.origin);
    target.searchParams.delete('page');
    target.searchParams.delete('jozee_page');

    const currentPath = window.location.pathname.replace(/\/$/, '');
    const targetPath = target.pathname.replace(/\/$/, '');
    if (currentPath === targetPath) return false;

    window.location.href = `${target.pathname}${target.search}${target.hash}`;
    return true;
  };

  const currentServerPage = () => {
    const url = new URL(window.location.href);
    const page = parseInt(url.searchParams.get('page') || '1', 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  };

  const pageFetchUrl = (page) => {
    const url = new URL(window.location.href);
    groups.forEach((group) => {
      url.searchParams.delete(`${parameterPrefix}${group}`);
    });
    url.searchParams.delete('jozee_page');
    url.searchParams.set('page', String(page));
    return `${url.pathname}${url.search}`;
  };

  const sortCollectionCardsByAvailability = (grid) => {
    if (!grid || grid.dataset.jozeeAvailabilitySorted === 'true') return;

    const cards = Array.from(grid.querySelectorAll('[data-jozee-product-card]'));
    cards
      .sort((first, second) => {
        const firstSoldOut = first.dataset.jozeeSoldOut === 'true' ? 1 : 0;
        const secondSoldOut = second.dataset.jozeeSoldOut === 'true' ? 1 : 0;
        return firstSoldOut - secondSoldOut;
      })
      .forEach((card) => grid.appendChild(card));

    grid.dataset.jozeeAvailabilitySorted = 'true';
  };

  const ensureCollectionProductsLoaded = async (grid) => {
    if (!grid || grid.dataset.jozeeCollectionProductsLoaded === 'true') return;
    if (grid.dataset.jozeeCollectionProductsLoading === 'true') {
      while (grid.dataset.jozeeCollectionProductsLoading === 'true') {
        await new Promise((resolve) => {
          window.setTimeout(resolve, 80);
        });
      }
      return;
    }

    const serverPages = parseInt(grid.dataset.jozeeServerPages || '1', 10);
    if (!Number.isFinite(serverPages) || serverPages <= 1) {
      sortCollectionCardsByAvailability(grid);
      grid.dataset.jozeeCollectionProductsLoaded = 'true';
      return;
    }

    grid.dataset.jozeeCollectionProductsLoading = 'true';
    const currentPage = currentServerPage();
    const existingHandles = new Set(
      Array.from(grid.querySelectorAll('[data-jozee-product-card]'))
        .map((card) => card.querySelector('a[href*="/products/"]')?.getAttribute('href') || card.textContent?.trim())
        .filter(Boolean),
    );

    try {
      const pages = Array.from({ length: serverPages }, (_, index) => index + 1).filter((page) => page !== currentPage);
      const parser = new DOMParser();

      for (const page of pages) {
        const response = await fetch(pageFetchUrl(page), { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Unable to load all products page ${page}`);
        const html = await response.text();
        const doc = parser.parseFromString(html, 'text/html');
        const cards = Array.from(doc.querySelectorAll('#product-grid [data-jozee-product-card]'));

        cards.forEach((card) => {
          const handleKey = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || card.textContent?.trim();
          if (!handleKey || existingHandles.has(handleKey)) return;
          existingHandles.add(handleKey);
          grid.appendChild(document.importNode(card, true));
        });
      }

      sortCollectionCardsByAvailability(grid);
      grid.dataset.jozeeCollectionProductsLoaded = 'true';
      grid.dataset.jozeeAllProductsLoaded = 'true';
      grid.dataset.jozeeServerPages = '1';
      document.dispatchEvent(new CustomEvent('jozee:collection-products-loaded'));
    } catch (error) {
      sortCollectionCardsByAvailability(grid);
      console.warn('[Jozee filters] Could not load every collection page before filtering.', error);
    } finally {
      delete grid.dataset.jozeeCollectionProductsLoading;
    }
  };

  const cacheServerProductCount = () => {
    productCountElements().forEach((target) => {
      const text = target.textContent?.trim();
      if (text && !target.dataset.jozeeServerCountText) {
        target.dataset.jozeeServerCountText = text;
      }
      if (target.dataset.productCount && !target.dataset.jozeeServerProductCount) {
        target.dataset.jozeeServerProductCount = target.dataset.productCount;
      }
      if (target.dataset.totalCount && !target.dataset.jozeeServerTotalCount) {
        target.dataset.jozeeServerTotalCount = target.dataset.totalCount;
      }
    });
  };

  const readSelections = () => {
    const selections = {};
    groups.forEach((group) => {
      selections[group] = unique(
        filterInputs()
          .filter((input) => input.dataset.jozeeFilterGroup === group && input.checked)
          .map((input) => input.value),
      );
    });
    return selections;
  };

  const writeSelectionsToUrl = () => {
    const url = new URL(window.location.href);
    groups.forEach((group) => {
      url.searchParams.delete(`${parameterPrefix}${group}`);
    });

    const selections = readSelections();
    groups.forEach((group) => {
      selections[group].forEach((value) => {
        url.searchParams.append(`${parameterPrefix}${group}`, value);
      });
    });

    url.searchParams.delete('jozee_page');
    url.searchParams.delete('page');
    window.history.pushState({}, '', `${url.pathname}${url.search}${url.hash}`);
  };

  const syncInputsFromUrl = () => {
    const url = new URL(window.location.href);
    const currentHandle = collectionHandle();

    groups.forEach((group) => {
      const urlValues = url.searchParams.getAll(`${parameterPrefix}${group}`);
      const groupInputs = filterInputs().filter((input) => input.dataset.jozeeFilterGroup === group);
      const currentGroupContainsPage = groupInputs.some((input) => input.value === currentHandle);

      groupInputs.forEach((input) => {
        input.checked = urlValues.includes(input.value) || (urlValues.length === 0 && currentGroupContainsPage && input.value === currentHandle);
      });
    });
  };

  const cardCollections = (card) => new Set((card.dataset.jozeeCollections || '').split(/\s+/).filter(Boolean));

  const matchesSelections = (card, selections, ignoredGroup = null, candidate = null) => {
    const collections = cardCollections(card);

    return groups.every((group) => {
      let selected = selections[group] || [];
      if (group === ignoredGroup) selected = candidate ? [candidate] : [];
      if (!selected.length) return true;
      return selected.some((handle) => collections.has(handle));
    });
  };

  const updateOptionCounts = (cards, selections) => {
    const optionItems = Array.from(document.querySelectorAll('[data-jozee-filter-option]'));

    optionItems.forEach((item) => {
      const input = item.querySelector('[data-jozee-filter-input]');
      const countTarget = item.querySelector('[data-jozee-filter-count]');
      if (!input) return;

      const group = input.dataset.jozeeFilterGroup;
      const count = cards.filter((card) => matchesSelections(card, selections, group, input.value)).length;
      const label = item.querySelector('.facets__label');

      if (countTarget) countTarget.textContent = ` (${count})`;
      if (label) {
        label.classList.toggle('disabled', count === 0 && !input.checked);
        label.classList.toggle('active', input.checked);
      }
      input.disabled = count === 0 && !input.checked;
    });
  };

  const updateSelectedLabels = (selections) => {
    document.querySelectorAll('[data-jozee-filter-group].jozee-collection-filter').forEach((details) => {
      const group = details.dataset.jozeeFilterGroup;
      const count = selections[group]?.length || 0;
      const countTarget = details.querySelector('[data-jozee-filter-selected-count]');
      const labelTarget = details.querySelector('[data-jozee-filter-selected-label]');

      if (countTarget) {
        countTarget.textContent = count > 0 ? ` (${count})` : '';
        countTarget.classList.toggle('hidden', count === 0);
      }
      if (labelTarget) {
        labelTarget.textContent = count > 0 ? `${count} selected` : 'No filters selected';
      }
    });
  };

  const updateProductCount = (visibleCount, totalCount = null) => {
    const text = Number.isFinite(totalCount) && visibleCount !== totalCount
      ? `${visibleCount} of ${totalCount} products`
      : `${visibleCount} products`;

    productCountElements().forEach((target) => {
      target.textContent = text;
      target.dataset.productCount = String(visibleCount);
      if (Number.isFinite(totalCount)) {
        target.dataset.totalCount = String(totalCount);
      }
    });

    mobileProductCountElements().forEach((target) => {
      target.textContent = text;
    });
  };

  const preserveServerProductCount = () => {
    const source = productCountElements().find((target) => target.dataset.jozeeServerCountText)
      || productCountElements().find((target) => target.textContent?.trim());
    const text = source?.dataset.jozeeServerCountText || source?.textContent?.trim();
    if (!text) return;

    productCountElements().forEach((target) => {
      target.textContent = text;
      if (source?.dataset.jozeeServerProductCount) {
        target.dataset.productCount = source.dataset.jozeeServerProductCount;
      }
      if (source?.dataset.jozeeServerTotalCount) {
        target.dataset.totalCount = source.dataset.jozeeServerTotalCount;
      }
    });

    mobileProductCountElements().forEach((target) => {
      target.textContent = text;
    });
  };

  const updateJozeeProductCount = (visibleCount) => {
    updateProductCount(visibleCount);
  };

  const applyJozeeFilters = async () => {
    syncInputsFromUrl();
    cacheServerProductCount();

    const grid = document.querySelector('[data-jozee-client-pagination="true"]');
    if (!grid) return;

    await ensureCollectionProductsLoaded(grid);

    const cards = Array.from(grid.querySelectorAll('[data-jozee-filter-card]'));
    const selections = readSelections();
    let visibleCount = 0;

    cards.forEach((card) => {
      const visible = matchesSelections(card, selections);
      card.dataset.jozeeFilterHidden = visible ? 'false' : 'true';
      if (visible) visibleCount += 1;
    });

    updateOptionCounts(cards, selections);
    updateSelectedLabels(selections);
    if (hasExplicitJozeeSelections()) {
      updateJozeeProductCount(visibleCount);
    } else {
      preserveServerProductCount();
    }

    document.dispatchEvent(new CustomEvent('jozee:filters-updated'));
  };

  document.addEventListener(
    'input',
    (event) => {
      if (!event.target.matches?.('[data-jozee-filter-input]')) return;
      event.stopPropagation();
      if (navigateToCollection(event.target)) return;
      writeSelectionsToUrl();
      applyJozeeFilters();
    },
    true,
  );

  document.addEventListener('click', (event) => {
    const clearButton = event.target.closest('[data-jozee-filter-clear]');
    if (!clearButton) return;

    event.preventDefault();
    const group = clearButton.dataset.jozeeFilterClear;
    filterInputs()
      .filter((input) => input.dataset.jozeeFilterGroup === group)
      .forEach((input) => {
        input.checked = false;
      });
    writeSelectionsToUrl();
    applyJozeeFilters();
  });

  window.addEventListener('popstate', applyJozeeFilters);
  document.addEventListener('DOMContentLoaded', applyJozeeFilters);

  const observer = new MutationObserver((mutations) => {
    const changed = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return node.matches?.('[data-jozee-client-pagination="true"], [data-jozee-filter-input]')
          || node.querySelector?.('[data-jozee-client-pagination="true"], [data-jozee-filter-input]');
      }),
    );

    if (changed) applyJozeeFilters();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
